var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.4,
    height: 71.7,
    viewBox: "0 0 70.4 91.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Lock_228827",
    transform: "translate(180.2 -336.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M22.1,95.8H77.9a7.277,7.277,0,0,0,7.3-7.3v-40a7.277,7.277,0,0,0-7.3-7.3h-.2V31.6a27.5,27.5,0,0,0-55,0v9.6h-.6a7.277,7.277,0,0,0-7.3,7.3v40A7.341,7.341,0,0,0,22.1,95.8ZM54.3,70.3a1.488,1.488,0,0,0-.7,1.5v8.8h0a3.31,3.31,0,0,1-1.6,3,3.4,3.4,0,0,1-5.1-3h0V71.8a1.42,1.42,0,0,0-.7-1.4A6.632,6.632,0,0,1,44,62.2a6.8,6.8,0,0,1,13,2.7A6.174,6.174,0,0,1,54.3,70.3ZM34.8,31.7a15.5,15.5,0,0,1,31,0v9.6h-31Z",
    transform: "translate(-195 332)",
    fill: "#696868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSvg);
export default __webpack_public_path__ + "static/media/lock_svg.7dc638720d0d75774ee1724d4fc3a2b4.svg";
export { ForwardRef as ReactComponent };